import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CoreConstants } from "../../../core/models/constants/core.constants";
import DynamicForm from "../../../core/presentations/DynamicForm";
import Validators from "../../../ui/helpers/validators";
import { OptionsConstants } from "../../../ui/models/constants/options.constants";
import NoLabelFieldTemplate from "../../../ui/templates/fields/NoLabelFieldTemplate";
import TopLabelFieldTemplate from "../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../ui/widgets/custom/buttons/PrwcBasicButton";

const SignUp = (props: any) => {

  const {onSubmit} = props;
  const { t } = useTranslation();
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };
  
  const handleOnSubmit = (data: any) => {
    onSubmit(data.formData);
  };

  const onError = (data: any) => {};

  const validationSchema: any = {
    firstName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signUp.validation.firstNameRequired",
        },
      ],
    },
    lastName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signUp.validation.lastNameRequired",
        },
      ],
    },
    workEmailId: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signUp.validation.workEmailRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_EMAIL,
              value
            );
          },
          messageKey: "signUp.validation.workEmailInvalid",
        },
        {
          validate: (value: string) => {
            return !Validators.isPersonalEmail(value);
          },
          messageKey: "signUp.validation.workEmailNotWorkEmail",
        },
      ],
    },
    companyName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signUp.validation.companyNameRequired",
        },
      ],
    },
    numberOfEmployees: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isNumberEmpty(value);
          },
          messageKey: "signUp.validation.numberOfEmployeesRequired",
        },
      ],
    },
    country: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "signUp.validation.countryRequired",
        },
      ],
    },
    termsOfService: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isBooleanEmpty(value);
          },
          messageKey: "signUp.validation.acceptTermsOfServiceRequired",
        },
      ],
    },
  };

  const schema: any = {
    type: "object",
    properties: {
      firstName: {
        type: "string",
        title: t("signUp.label.firstName"),
      },
      lastName: {
        type: "string",
        title: t("signUp.label.lastName"),
      },
      workEmailId: {
        type: "string",
        title: t("signUp.label.workEmailId"),
        default: "",
      },
      companyName: {
        type: "string",
        title: t("signUp.label.companyName"),
        default: "",
      },
      numberOfEmployees: {
        type: "number",
        title: t("signUp.label.numberOfEmployees"),
      },
      country: {
        type: "string",
        title: t("signUp.label.country"),
        default: "",
      },

      termsOfService: {
        type: "boolean",
        title: "",
        default: false,
      },
    },
    required: [
      "firstName",
      "lastName",
      "workEmailId",
      "companyName",
      "numberOfEmployees",
      "country",
      "termsOfService",
    ],
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    firstName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-sm-6 p-md-12 p-lg-6",
      "ui:emptyValue": "",
    },
    lastName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-sm-6 p-md-12 p-lg-6",
    },
    workEmailId: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
    },
    companyName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
    },
    numberOfEmployees: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-sm-6 p-md-12 p-lg-6",
      "ui:options": {
        dropdownOptions: OptionsConstants.NoOfEmployees,
        showClear: true,
      },
    },
    country: {
      "ui:widget": "prwCountryDropdown",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-sm-6 p-md-12 p-lg-6",
    },
    reCaptcha: {
      "ui:widget": "prwReCaptcha",
      "ui:FieldTemplate": NoLabelFieldTemplate,
      classNames: "p-col-12",
    },
    termsOfService: {
      "ui:widget": "prwAcceptTermsOfServices",
      "ui:FieldTemplate": NoLabelFieldTemplate,
      classNames: "p-col-12",
    },
  };

  const formButtons = () => {
    return (
      <PrwcBasicButton
        type="submit"
        labelKey="signUp.action.signUp"
        className="bg-blue-700 p-col-12 p-button-sm"
      ></PrwcBasicButton>
    );
  };

  return (
    <div className="p-6 bg-gray-100 rounded-md">
      {/* Login */}
      {/* <Button label="Get Rates" onClick={getRates} />
   
      <Button label="Logout" onClick={doLogoout} /> */}
      <div className="text-2xl font-semibold">{t("signUp.label.signUp")}</div>
      <div className="text-sm ">
        {t("signUp.label.typeInYourAndCompanyInfo")}
      </div>
      <div className="mt-4">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={handleOnSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
    </div>
  );
};

export default SignUp;
